import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { getRoleToPageAccess } from "../config/apiService"; // ✅ backend call
import "../styles/HomePage.css";

// same slugify utility...
const slugify = (str) =>
  decodeURIComponent(str)
    .toLowerCase()
    .normalize("NFKD")
    .replace(/&/g, "and")
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/--+/g, "-")
    .trim();

const HomePage = () => {
  const { accounts } = useMsal();
  const navigate = useNavigate();
  const displayName = accounts[0]?.name || accounts[0]?.username || "User";

  // ✅ store backend report data
  const [reportData, setReportData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getRoleToPageAccess();
        setReportData(data);
      } catch (error) {
        console.error("Failed to fetch report data:", error);
      }
    };

    fetchData();
  }, []);

  // ✅ Distinct dashboards after backend loads
  const dashboards = Array.from(
    new Set(reportData.map((entry) => entry.dashboard))
  );

  // ✅ save username in localStorage
  if (accounts[0]) {
    localStorage.setItem("Username", accounts[0].username);
  }

  return (
    <Box className="home-root">
      {/* Top-left greeting */}
      <Box className="home-greeting">
        <Typography variant="h4" gutterBottom>
          Hello {displayName}
        </Typography>
        <Typography variant="h6" gutterBottom>
          Welcome to Bosch Smart Pulse
        </Typography>

        <Stack direction="row" spacing={2} flexWrap="wrap">
              <Button
                variant="contained" 
                color="primary"
                onClick={() =>
                  navigate(
                    "/smart-pulse-reports/meter-traceability/wfm-vs-hes-vs-mdm"
                  )
                }
                className="home-button">
                SMART PULSE REPORTS
              </Button>
              
              <Button
                variant="contained" 
                color="primary"
                onClick={() =>
                  navigate(
                    "/smart-pulse-reports/to-do-list/to-do-list-summary"
                  )
                }
                className="home-button">
                TO DO LIST SUMMARY
              </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default HomePage;
